export default __webpack_public_path__ + "static/media/IMG-20241005-WA0029.8e8c2c82.jpg";